// extracted by mini-css-extract-plugin
export default {"hstack":"stack_hstack__jaJuQ","column":"stack_column__LEzZ-"};